module.exports = __webpack_public_path__ + "img/isbn_10_information.3762b7a4.jpg";